import { MODULE_NAME } from 'modules/scheduled-reports/config/routes/module';
import { isNetworkAccountType } from '../../../../../../account-management';
import { FEATURE_FLAGS } from '../../../../../../taboola-common-frontend-modules/account-configurations';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { columnDefinitions } from './columnDefinitions';
import { DYNAMIC_REPORTS_REPORT_ID } from './dynamicReportsReportId';
import { defaultColumns } from './reportPresets';

export const dynamicReportsReportConfig = {
    id: DYNAMIC_REPORTS_REPORT_ID,
    label: 'Saved reports',
    module: MODULE_NAME,
    accountConfigurations: { [FEATURE_FLAGS.DYNAMIC_REPORTS_ENABLED]: 'true' },
    permissions: ['PERFORMANCE_DYNAMIC_REPORT_VIEW', 'DYNAMIC_REPORTS_VIEW'],
    visibilityCondition: ({ selectedAccount: { type } }) => !isNetworkAccountType(type),
    endpoint: accountId => `/${accountId}/dynamic-reports`,
    rowIdField: FIELDS.DYNAMIC_REPORT_ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
};
